import constants, { ACCESS_TOKEN } from '../../../settings/shared/constants'
import axiosClient from '../../common';

function _constructHeader() {
    let jwtToken = localStorage.getItem(ACCESS_TOKEN);
    let headers = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + jwtToken
    }
    return headers;
}

function PostStorageConfiguration(configData) {
    return axiosClient({
        url: constants.api.storageConfig.postStorageConfig,
        method: 'POST',
        headers: _constructHeader(),
        data: configData
    });
}

function getAllStorageConfig() {
    return axiosClient({
        url: constants.api.storageConfig.getAllStorageConfig,
        method: 'GET',
        headers: _constructHeader(),
        data: ''
    });
}

function getAllStorageConfigById(id) {
    return axiosClient({
        url: constants.api.storageConfig.getAllStorageConfigbyId + id,
        method: 'GET',
        headers: _constructHeader(),
        data: ''
    });
}

function deleteStorageConfig(id) {
    return axiosClient({
        url: constants.api.storageConfig.deleteStorageConfigbyId + id,
        method: 'DELETE',
        headers: _constructHeader(),
        data: ""
    });
}

function UpdateStorageConfig(id, configData) {
    return axiosClient({
        url: constants.api.storageConfig.updateStorageConfig + id,
        method: 'PUT',
        headers: _constructHeader(),
        data: configData
    });
}


const StorageConfigService = {
    PostStorageConfiguration,
    getAllStorageConfig,
    getAllStorageConfigById,
    deleteStorageConfig,
    UpdateStorageConfig
}

export default StorageConfigService;
